import { translations } from 'locales/translations';
import { _t } from 'locales/utils/messages';

export const messages = {
  mustInclude: () => _t(translations.components.PasswordValidation.mustInclude, 'Must include'),
};
